import { useMutationState } from "@tanstack/react-query";
import { usePathname } from "expo-router";
import { useCallback, useEffect, useState } from "react";

export function useQRBadgeState() {
  const [hasBadge, setBadge] = useState(false);
  const path = usePathname();
  const mutations = useMutationState({
    filters: { status: "success", exact: true, mutationKey: ["create_org"] },
  });

  const ts = mutations?.[0]?.submittedAt;

  useEffect(() => {
    if (mutations.length && !hasBadge && ts) {
      setBadge(true);
    }
  }, [ts]);

  useEffect(() => {
    if (path.startsWith("/qrs") && hasBadge) {
      setBadge(false);
    }
  }, [path]);

  return hasBadge;
}
